import { CompassCardUI } from '@scale/compass-ui/types';
import {
  HubstaffMemberActionsCardShared,
  HubstaffMemberActionsSchemaType,
  HUBSTAFF_MEMBER_ACTIONS,
  HubstaffUserIdentityType,
} from '@scale/genai-compass-shared/cards/hubstaff_member_actions';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import HubstaffMemberActionsCardComponent from './HubstaffMemberActionsCardComponent';

export const HubstaffMemberActionsCardInput: CompassCardUI<HubstaffMemberActionsSchemaType> = {
  ...HubstaffMemberActionsCardShared,
  title: 'Hubstaff Member Actions',
  icon: 'users',
  toolTip: 'Perform bulk Hubstaff member management operations',
  defaultContext: {
    cardType: HUBSTAFF_MEMBER_ACTIONS,
    hubstaffProjectId: undefined,
    hubstaffProjectName: undefined,
    action: undefined as any,
    userIdentifierColumn: undefined,
    userIdentityType: HubstaffUserIdentityType.CORP_EMAIL,
    memberRole: undefined,
    timeTracking: undefined,
  },
  button: {
    icon: faUsers,
    title: 'Hubstaff Member Actions',
  },
  component: HubstaffMemberActionsCardComponent,
  showOutput: true, // Show the results table after execution
};
